/* eslint-disable prettier/prettier */
const Styles = {
  CompContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: "#7DA5FF",
    padding: ".5rem",
    borderRadius: "3px",
    marginBottom: "6px",
  },
  titleContainer: {
    fontWeight: "400",
    fontSize: "20px",
    color: "#8C8C8C",
  },
  OutlinInput: {
    color: "#8C8C8C",
    borderRadius: "2px",
  },
  tableHeadCells: {
    // padding: "8px",
    color: "#000000",
    fontWeight: 600,
    background: "#BAD9EC",
  },
};

export default Styles;
